import { apiClient } from "@/api"
import Alerter from "@/common/alerter"
import { RECEIVE_SESSIONS_OPTIONS, SCHOOL_ADMIN_MESSAGES, SCHOOL_ADMIN_PATHS } from "@/constants"
import React from "react"
import CreateOrUpdateForm from "../actions/create_or_update_form"

export const SchoolAdminEditPage = ({ schoolAdmin, receiveSessions }) => {
  const onSubmit = async (event, id, email, firstName, lastName, receiveSessions) => {
    event.preventDefault()

    const school_admin = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      receive_session_reports: receiveSessions === RECEIVE_SESSIONS_OPTIONS.YES,
    }

    try {
      await apiClient.put(`${SCHOOL_ADMIN_PATHS.apiBase}/${id}`, school_admin)
      Alerter.success(SCHOOL_ADMIN_MESSAGES.updateSuccess)
      window.location.replace(SCHOOL_ADMIN_PATHS.users)
    } catch (error) {
      Alerter.error(error.response.data.error)
    }
  }

  return (
    <CreateOrUpdateForm
      title={"Edit School Admin"}
      onSubmit={onSubmit}
      initialValues={{
        schoolAdmin,
        receiveSessions,
      }}
    />
  )
}
